import { formatYenPerKwh, Price } from "../../../../price";
import { AlgoConfiguration, AlgoData } from "../../types";

/**
 * The algo grid's Price cell, in yen/kWh.
 *
 * Returns a string in every branch because the arbitrageur has no price, only a
 * spread, which renders as `"1.5(spread)"` — that sentinel is why the column is
 * `singleSelect` and sorts lexicographically.
 *
 * Both numeric sources are yen/MWh: `algo_data.price` is the venue's scaled
 * integer, and `configuration.price` is the plain decimal we ourselves sent.
 */
export const getPriceField = (
  algo_data: AlgoData | undefined,
  configuration: AlgoConfiguration
): string => {
  if (algo_data?.price?.price != null) {
    return formatYenPerKwh(Price.fromScaledMwh(algo_data.price.price));
  }

  if (configuration.price != undefined) {
    return formatYenPerKwh(
      Price.fromYenPerMwh(configuration.price)
    );
  }

  if (configuration.reference_price != undefined) {
    return formatYenPerKwh(
      Price.fromYenPerMwh(configuration.reference_price)
    );
  }

  return "N/A";
};
